<template>
  <div>
    {{ cellProps.data.fullname }}
  </div>
</template>

<script>
export default {
  name: "OwnerCell",
  props: {
    cellProps: {
      required: true,
      type: Object,
    },
  }
};
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
</style>
